<h1 mat-dialog-title class="title">
  <span>Delete files</span>
</h1>

<mat-dialog-content>
  <anon-alert status="danger">You may be deleting user data. After you delete this, it can not be recovered.</anon-alert>
</mat-dialog-content>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="warn" type="button" (click)="dialogRef.close(true)">Delete</button>
</div>
